import { Observable } from "rxjs";
import { Component } from "@angular/core";
import { Store } from "@ngrx/store";
import { User } from "../../../models/user.model";

@Component({
    selector: "app-viatim-modal",
    templateUrl: "./viatim-modal.component.html",
    styleUrls: ["./viatim-modal.component.scss"],
})
export class ViatimModalComponent {
    currentUser$: Observable<User> = this.store.select((state) => state.currentUser);

    constructor(private store: Store<{ currentUser: User }>) {}
}
